import React, { useEffect, useRef } from 'react';
import { Space, Spin, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import { initializeAuthSession } from '../../utils/authSession';
import { clearStorage, openNotification } from '../../utils';

const LoginByToken = () => {
  const { tokenId } = useParams<{ tokenId: string }>();
  const navigate = useNavigate();
  const requestStarted = useRef(false);

  useEffect(() => {
    if (requestStarted.current) return;
    requestStarted.current = true;

    const login = async () => {
      if (!tokenId) {
        clearStorage();
        openNotification('error', 'Başarısız', 'Giriş tokenı bulunamadı.');
        return;
      }
      try {
        const response = await AuthService.loginByTokenId(tokenId);
        await initializeAuthSession(response.data);
        navigate('/', { replace: true });
      } catch {
        clearStorage();
        openNotification(
          'error',
          'Başarısız',
          'Giriş yapılamadı. Token geçersiz veya daha önce kullanılmış olabilir.'
        );
      }
    };
    void login();
  }, [navigate, tokenId]);

  return (
    <div style={{ minHeight: 320, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Space direction="vertical" align="center" size="large">
        <Spin size="large" />
        <Typography.Text>Giriş yapılıyor, lütfen bekleyiniz.</Typography.Text>
      </Space>
    </div>
  );
};

export default LoginByToken;

